import { render, staticRenderFns } from "./CharitysIndex.vue?vue&type=template&id=a73daefe&"
import script from "./CharitysIndex.vue?vue&type=script&lang=js&"
export * from "./CharitysIndex.vue?vue&type=script&lang=js&"
import style0 from "./CharitysIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports